import Header from "./components/Header";
import Hero from "./components/Hero";
import WatchSection from "./components/WatchSection";
import BlastSection from "./components/BlastSection";
import ChainSection from "./components/ChainSection";
import RippleSection from "./components/RippleSection";
import LifecycleSection from "./components/LifecycleSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WatchSection />
        <BlastSection />
        <ChainSection />
        <RippleSection />
        <LifecycleSection />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}